module.exports = __webpack_public_path__ + "img/undp.e95dd403.jpg";